import { render } from "./CruImported.vue?vue&type=template&id=6d4d9311"
import script from "./CruImported.vue?vue&type=script&lang=js"
export * from "./CruImported.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__